export default function WhyChooseUs() {
  return (
    <section className="mb-12 rounded-xl px-0 py-3 sm:px-2 sm:py-4 md:p-8">
      <h2 className="mb-4 text-center text-lg font-bold text-[var(--dash-text-strong)] sm:mb-5 sm:text-xl md:mb-6 md:text-2xl">
        Why choose us ?
      </h2>
      <div className="rounded-xl border border-[var(--dash-border)] bg-[var(--dash-surface)] p-4 shadow-xl sm:p-6 md:p-8">
        <div className="flex flex-row flex-nowrap items-start justify-center gap-1.5 sm:gap-3 md:gap-8 lg:gap-10">
          <div className="flex min-w-0 flex-1 flex-col items-center gap-1.5 text-center sm:gap-2 md:gap-3">
            <img
              src="/like.png"
              alt=""
              className="h-8 w-8 shrink-0 object-contain invert dark:invert-0 sm:h-10 sm:w-10 md:h-14 md:w-14"
              aria-hidden
            />
            <h3 className="w-full max-w-[9.5rem] break-words text-[0.625rem] font-bold leading-snug text-[var(--dash-text-strong)] sm:max-w-none sm:text-xs md:text-sm">
              Highly Trusted by
              <br />
              100k+ People
            </h3>
          </div>
          <div className="flex min-w-0 flex-1 flex-col items-center gap-1.5 text-center sm:gap-2 md:gap-3">
            <img
              src="/bulb.png"
              alt=""
              className="h-8 w-8 shrink-0 object-contain invert dark:invert-0 sm:h-10 sm:w-10 md:h-14 md:w-14"
              aria-hidden
            />
            <h3 className="w-full max-w-[9.5rem] break-words text-[0.625rem] font-bold leading-snug text-[var(--dash-text-strong)] sm:max-w-none sm:text-xs md:text-sm">
              7+ Years of Chrome
              <br />
              Extension Expertise
            </h3>
          </div>
          <div className="flex min-w-0 flex-1 flex-col items-center gap-1.5 text-center sm:gap-2 md:gap-3">
            <img
              src="/ratings.png"
              alt=""
              className="h-8 w-8 shrink-0 object-contain invert dark:invert-0 sm:h-10 sm:w-10 md:h-14 md:w-14"
              aria-hidden
            />
            <h3 className="w-full max-w-[9.5rem] break-words text-[0.625rem] font-bold leading-snug text-[var(--dash-text-strong)] sm:max-w-none sm:text-xs md:text-sm">
              Highly Rated on
              <br />
              Chrome Webstore
            </h3>
          </div>
        </div>
      </div>
      <p className="sr-only">
        Highly trusted by over one hundred thousand people; more than seven years of Chrome
        extension experience; highly rated on the Chrome Web Store.
      </p>
    </section>
  );
}
